export default __webpack_public_path__ + "locales/si/HotkeysPanel.json?hash=8e7b06cae6e35af866877ad2071e5713";